import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import useQueryParamTabs from 'App/hooks/useQueryParamTabs';
import Users from './Users';
import styled from '@emotion/styled';
import DisabledUsers from './DisabledUsers';
import Branches from './Branches';
import useFetchDisabledCompanySsoUsersQuery from 'App/hooks/useFetchDisabledCompanySsoUsersQuery';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import hasLength from 'App/utils/hasLength';
import PendingActivation from './PendingActivation';
import { MdOutlineNewReleases } from 'react-icons/md';

const propTypes = {};

const defaultProps = {};

const paramTabConfig = {
    validTabs: ['users', 'disabled', 'branches'],
    defaultTab: 'users',
};

const StyledTabs = styled(Tabs)`
    .tab-pane {
        margin-top: 1.25rem;
    }
`;

function UserManagerTabs() {
    const { defaultActiveKey, setCurrentTab } = useQueryParamTabs(paramTabConfig);

    const disabledSsoUsers = useFetchDisabledCompanySsoUsersQuery();
    const isSsoEnabled = useIsPermitted(PERMISSION_TYPES.SSO_ENABLED);

    return (
        <StyledTabs defaultActiveKey={defaultActiveKey} id="user-manager-tabs" onSelect={setCurrentTab}>
            <Tab eventKey="users" title="Users">
                <Users />
            </Tab>
            {isSsoEnabled && hasLength(disabledSsoUsers.data) ? (
                <Tab
                    eventKey="pending-activation"
                    title={
                        <span>
                            Pending Activation <MdOutlineNewReleases />
                        </span>
                    }
                >
                    <PendingActivation />
                </Tab>
            ) : null}
            <Tab eventKey="disabled" title="Disabled Users">
                <DisabledUsers />
            </Tab>
            <Tab eventKey="branches" title="Branches">
                <Branches />
            </Tab>
        </StyledTabs>
    );
}

UserManagerTabs.propTypes = propTypes;
UserManagerTabs.defaultProps = defaultProps;

export default UserManagerTabs;
